import React from 'react';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';
import Form from '../form/Form';
import FieldGroup from '../field_group/FieldGroup';
import { listACBrand } from '../../redux/references/ac_actions';
import { requiredValidator } from '../field_group/validators';
import { fromCoolingCap, getErrorValue } from '../../utils/utility';

export class ChillerDetail extends React.Component {
  constructor(props) {
    super(props);
    this.formRef = undefined;
    this.state = { isShowCompressorTypeSelect: props.ac.compressor_type !== 'na' };
  }

  renderOption(item, prefix) {
    return (
      <option key={prefix ? `${prefix}${item.id}` : item.id} value={item.id}>
        {item.name}
      </option>
    );
  }

  getACData() {
    return this.formRef.getFormData(['cooling_capacity']);
  }

  componentDidMount() {
    this.props.listBrand();
  }

  chillerTypeChangeHandler(type) {
    const isAbsorption = type.toLowerCase().indexOf('absorption') !== -1;
    this.setState({ isShowCompressorTypeSelect: !isAbsorption });
  }

  render() {
    const {
      name,
      brand_id,
      type,
      compressor_type,
      cooling_capacity,
      unit,
      power_required,
      description,
      image,
    } = this.props.ac;

    const { t, disabled, fieldErrors, ac, ...otherAttr } = this.props;
    const customAttr = { disabled };
    return (
      <Form
        image={image}
        {...otherAttr}
        ref={ref => (this.formRef = ref)}
        errorMessage={getErrorValue(fieldErrors, 'detail')}
      >
        <FieldGroup
          id="air-conditioning-chiller-name"
          field="name"
          type="text"
          label={t('name')}
          placeholder="Name"
          value={name}
          validators={[requiredValidator]}
          errorMessage={getErrorValue(fieldErrors, 'name')}
          {...customAttr}
        />
        <FieldGroup
          id="air-conditioning-chiller-type"
          field="type"
          componentClass="select"
          label={t('type')}
          placeholder={t('type')}
          value={type}
          defaultDirty={true}
          onValueChange={type => this.chillerTypeChangeHandler(type)}
          {...customAttr}
        >
          {this.props.types.map(type => this.renderOption(type, 'act'))}
        </FieldGroup>
        <FieldGroup
          id="air-conditioning-chiller-brand"
          field="brand_id"
          componentClass="select"
          label={t('brand')}
          placeholder={t('brand')}
          value={brand_id}
          defaultDirty={true}
          {...customAttr}
        >
          {this.props.brands.map(brand => this.renderOption(brand, 'act'))}
        </FieldGroup>
        {this.state.isShowCompressorTypeSelect &&
          <FieldGroup
            id="air-conditioning-chiller-compressor-type"
            field="compressor_type"
            componentClass="select"
            label={t('compressor type')}
            placeholder={t('compressor type')}
            value={compressor_type}
            defaultDirty={true}
            {...customAttr}
          >
            {this.props.compressorTypes.map(brand => this.renderOption(brand, 'ct'))}
          </FieldGroup>
        }
        <FieldGroup
          id="air-conditioning-chiller-cooling-capacity"
          field="cooling_capacity"
          type="number"
          label={t('cooling capacity')}
          placeholder="100"
          value={fromCoolingCap(cooling_capacity, unit)}
          validators={[requiredValidator]}
          errorMessage={getErrorValue(fieldErrors, 'cooling_capacity')}
          {...customAttr}
        />
        <FieldGroup
          id="air-conditioning-chiller-unit"
          field="unit"
          componentClass="select"
          label={t('unit')}
          value={unit}
          defaultDirty={true}
          {...customAttr}
        >
          {this.props.units.map(unit => this.renderOption(unit, 'acu'))}
        </FieldGroup>
        <FieldGroup
          id="air-conditioning-chiller-power-required"
          field="power_required"
          type="number"
          label={t('power (kW)')}
          placeholder="12"
          value={power_required}
          validators={[requiredValidator]}
          errorMessage={getErrorValue(fieldErrors, 'power_required')}
          {...customAttr}
        />
        <FieldGroup
          id="air-conditioning-chiller-description"
          field="description"
          componentClass="textarea"
          label={t('description')}
          value={description}
          {...customAttr}
        />
      </Form>
    );
  }
}

ChillerDetail.defaultProps = {
  ac: {},
};

const mapStateToProps = state => ({
  brands: state.reference.ac.brandList,
  types: state.reference.ac.clTypes,
  compressorTypes: state.reference.ac.compressorTypes,
  units: state.reference.ac.coolingCapacityUnit,
});

const mapDispatchToProps = dispatch => ({
  listBrand: () => dispatch(listACBrand()),
});

export default translate('translations', { withRef: true })(
  connect(
    mapStateToProps,
    mapDispatchToProps,
    null,
    { withRef: true },
  )(ChillerDetail),
);



// WEBPACK FOOTER //
// ./src/components/ac_central/ChillerDetail.js